import React from 'react';
import { useIncludedRelationshipContext } from 'Views/Page/Contexts/IncludedRelationshipContext';
import DataContainer from 'Components/UI/DataContainer';
import fr from 'facet-rest';
import Content
  from 'Views/Page/Content/Templates/WhatIfProposalPreviewTemplate/MainContentPicker/MainContentForScenarioSelectionRedefined/ClientProposalView/Content';
import { useSnackbarContext } from 'Context/SnackbarContext';

const ClientProposalView = () => {
  const {
    relationshipCollection, isInitializing,
  } = useIncludedRelationshipContext();
  const { displayErrorMessage } = useSnackbarContext();
  const [scenarioSelectionIntroPageResource, setScenarioSelectionIntroPageResource] = React.useState(null);

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        if (!relationshipCollection || !relationshipCollection.resources().head()) {
          return;
        }

        const introPageRel = relationshipCollection.resources().head().withRelationship(
          fr.relationships.facetPlanProposalScenarioSelectionIntroPage.name,
          (rel) => rel,
          () => null,
        );
        const clientViewRedefinedRel = relationshipCollection.resources().head().withRelationship(
          fr.relationships.clientViewRedefined.name,
          (rel) => rel,
          () => null,
        );
        if (!introPageRel && !clientViewRedefinedRel) {
          return;
        }

        if (clientViewRedefinedRel) {
          const [resource] = await clientViewRedefinedRel.link('related').get();
          setScenarioSelectionIntroPageResource(resource);
          return;
        }

        if (introPageRel) {
          const [resource] = await introPageRel.link('related').get();
          setScenarioSelectionIntroPageResource(resource);
        }
      } catch (err) {
        if (err.errors) {
          displayErrorMessage(err, err.errors);
        } else {
          displayErrorMessage(err, 'Error: Failed to load page. Please contact product support.');
        }
      }
    };

    fetchData();
  }, [relationshipCollection, relationshipCollection?.resources()?.head()?.etag()]);

  return (
    <DataContainer
      loading={isInitializing || !scenarioSelectionIntroPageResource}
      component={Content}
      componentProps={{
        resource: scenarioSelectionIntroPageResource,
      }}
    />
  );
};

ClientProposalView.defaultProps = {
};

ClientProposalView.propTypes = {
};

export default ClientProposalView;
